<div [ngSwitch]="state">
    <div *ngSwitchCase="eInvitation.Account">
        <h1>{{'On vous connait deja !' | transloco}}</h1>
        <p class="margin-bottom-50">
            {{'Vous ne pouvez pas vous inviter, vous etes deja membre de votre propre organisation ;)' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               [href]="(endpoints?.manager || 'https://manager.infomaniak.com') + '/v3/' + invitation.account.id"
               mat-raised-button
               color="primary">{{ 'Aller au manager' | transloco }}</a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Ksuite">
        <h1>{{'On vous connait deja !' | transloco}}</h1>
        <p class="margin-bottom-50">
            {{'Vous ne pouvez pas vous inviter, vous etes deja membre de votre propre organisation ;)' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               [href]="(endpoints?.manager || 'https://manager.infomaniak.com') + '/v3/' + invitation.account.id"
               mat-raised-button
               color="primary">{{ 'Aller au manager' | transloco }}</a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Drive">
        <h1>{{'On vous connait deja !' | transloco}}</h1>
        <p class="margin-bottom-50">
            {{'Vous ne pouvez pas vous inviter, vous etes deja membre de ce drive ;)' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               [href]="endpoints.drive + '/app/drive/'+invitation.extras.drive.id+'/files'"
               mat-raised-button
               color="primary">{{ 'Aller au drive' | transloco }}</a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Webmail">
        <h1>{{'On vous connait deja !' | transloco}}</h1>
        <p class="margin-bottom-50">
            {{'Vous ne pouvez pas vous inviter, vous accedez deja a cette adresse email ;)' | transloco}}</p>
        <div class="flex">
            <div class="xs-align-center padding-right-10">
                <a class="mat-elevation-z"
                   [href]="endpoints.workspace"
                   mat-raised-button
                   color="primary"> {{ 'Aller au workspace' | transloco }}</a>
            </div>
            <div class="xs-align-center">
                <a class="mat-elevation-z"
                   [href]="endpoints.login"
                   mat-raised-button
                   color="primary"> {{ 'Changer de compte' | transloco }}</a>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.KChat">
        <h1>{{'On vous connait deja !' | transloco}}</h1>
        <p class="margin-bottom-50">
            {{'Vous ne pouvez pas vous inviter comme utilisateur externe ;)' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               [href]="endpoints?.manager"
               mat-raised-button
               color="primary">{{ 'Aller au manager' | transloco }}</a>
        </div>
    </div>
</div>
